import { render } from "./ComSaveButton.vue?vue&type=template&id=afd55cee&ts=true"
import script from "./ComSaveButton.vue?vue&type=script&lang=ts"
export * from "./ComSaveButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__